import script from "./AtestadoModalAtendimento.vue?vue&type=script&setup=true&lang=js"
export * from "./AtestadoModalAtendimento.vue?vue&type=script&setup=true&lang=js"

import "./AtestadoModalAtendimento.vue?vue&type=style&index=0&id=5ab781a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ab781a0"]])

export default __exports__